// extracted by mini-css-extract-plugin
module.exports = {"text":"SubmissionsHelpText_text__1bTeR","accent":"SubmissionsHelpText_accent__1_129"};